export default "__VITE_ASSET__Cso_ISO3__"